import apiClient from './api';

export const userSessionService = {
  createUserSession: async (sessionData) => {
    try {
      const response = await apiClient.post('/usersessions', sessionData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUserSessionsByUser: async (userId) => {
    try {
      const response = await apiClient.get(`/usersessions/user/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
